import { render, staticRenderFns } from "./MainImageSection.vue?vue&type=template&id=2fc74000&scoped=true&"
import script from "./MainImageSection.vue?vue&type=script&lang=ts&"
export * from "./MainImageSection.vue?vue&type=script&lang=ts&"
import style0 from "./MainImageSection.vue?vue&type=style&index=0&id=2fc74000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc74000",
  null
  
)

export default component.exports